import { mapState } from 'vuex';

export default {
    name: 'fixedmessageicon',
    props: {
        
    },

    data : function(){

        return {
            loading : false
        }

    },

    created : () => {

    },

    watch: {
        icon : {
            immediate: true,
            handler(){
                this.init()
            }
        }
    },

    beforeRouteEnter (to, from, next) {
        next()
    },

    beforeRouteUpdate (to, from, next) {
        next()
    },

    computed: mapState({
        auth : state => state.auth,
        icon : function(){
            return this.$store.state.icon ? this.$store.state.icon.icon : null
        },

        message : function(){
            return this.$store.state.icon ? this.$store.state.icon.message : null
        }
    }),

    methods : {
        init : function(){
            var t = this

            setTimeout(function(){

                t.$store.commit('icon', null)

            }, 2000)
        }
    },
}